
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import TextBox from './../../zviz2/zviz/components/textbox';
import config from './../../config';
import {styleText} from './../../styles';
import {extend, trimLowerCase, cloneObject} from './../../zviz2/zviz/functions';

import detailsModel from './../../model/details';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.linkFields = new Map([
            ['eval_type', {v: 'regional', f: ['eval_type']}],
            ['tc_symbol', {s: 'eval', v: 'list', f: ['tc_symbol']}],
            ['eval_id', {s: 'eval', v: 'list', f: ['eval_id']}],
            ['subject_expertise_title', {v: 'regional', f: ['subject_expertise_title']}],
            ['eval_manager', {v: 'list', f: ['eval_manager']}],
            ['administrative_unit', {v: 'list', f: ['administrative_unit']}],
            ['funding_source', {v: 'regional', f: ['funding_source']}],
            ['tech_unit', {v: 'list', f: ['tech_unit']}],
            // ['eval_title', {s: 'eval', v: 'list', f: ['eval_id']}],
            ['theme_category', {v: 'regional', f: ['theme_category']}],
            ['theme', {v: 'regional', f: ['theme']}],
            ['ll_theme', {v: 'regional', f: ['ll_theme']}],
            ['gp_theme', {v: 'regional', f: ['gp_theme']}],
            ['rec_theme', {v: 'regional', f: ['rec_theme']}],
            ['region', {v: 'regional', f: ['region']}],
            ['country', {v: 'regional', f: ['country']}],
            ['eval_timing', {v: 'regional', f: ['eval_timing']}],
            // ['ll_desc', {s: 'll', v: 'list', f: ['ll_id']}],
            // ['gp_desc', {s: 'gp', v: 'list', f: ['gp_id']}],
            // ['rec_desc', {s: 'rec', v: 'list', f: ['rec_id']}],
            ['doc_title', {v: 'external', f: ['doc_id']}],
            ['eval_nature', {v: 'regional', f: ['eval_nature']}],
        ]);

    }


    getLines(){

        let result = [];

        let cf = this.models['details'].getCountField();

        let columns = config.screens.evaluations.slice(0);
        if(cf == 'll_id'){
            columns = config.screens.lessonsLearned.slice(0);
        }else if(cf == 'gp_id'){
            columns = config.screens.goodPractices.slice(0);
        }else if(cf == 'rec_id'){
            columns = config.screens.recommendations.slice(0);
        }

        let source = state.get('source');

        if(source == 'planned'){
            columns.push('management_response');
        }

        for(let field of columns){
            if(field == 'doc_id' || field == 'doc_type'){
                continue;
            }

            if(source == 'planned'){
                if(field == 'doc_title' || field == 'buttons'){
                    continue;
                }else if(field == 'completion_date'){
                    field = 'planned_completion_date';
                }
            }

            if(this.data[field] || field == 'management_response' || field.search('theme_combined') !== -1){
                // for planned evaluations management response is hard coded below  
                let value = field == 'management_response' ?'Pending' : this.data[field];
                result.push(extend({
                        properties: {
                            data: {
                                label: field,
                                value: value
                            },
                            style: {
                                borderTop: () => (
                                    field === 'eval_id' && source !== 'eval' && source !== 'planned' ?
                                        '1px solid #d3d2d3' : 'none'	
                                ),
                                marginTop: () => (
                                    field === 'eval_id' && source !== 'eval' && source !== 'planned' ?
                                        '10px' : '0'	
                                ),
                                paddingTop: () => (
                                    field === 'eval_id' && source !== 'eval' && source !== 'planned' ?
                                        '15px' : '5px'	
                                )
                            }
                        }
                    }, BlueprintLine));
            }
        }

        if(state.get('source') == 'eval'){
            result = result.concat(this.getButtons());
        }

        return result;

    }

    getButtons(){
        let buttonFields = ['ll_desc', 'gp_desc', 'rec_desc'];
        let titles = ['Lessons learned', 'Good practices', 'Recommendations & management responses'];
        let result = [];
        for(let i = 0; i < buttonFields.length; i++){
            let f = buttonFields[i];
            if(this.data[f]){
                let length = this.data[f].length;
                if(length > 0 && this.data[f][0] != '__EMPTY__'){
                    let cF = this.models['details'].getCountField();
                    result.push(extend({
                        properties: {
                            style: extend({
                                background: '#1E2DBE url(\'' + config.imgPath + 'iconlist.png\') 3px center no-repeat',
                                color: 'white',
                                fontSize: '10pt',
                                padding: '0px 7px 0px 30px',
                                height: '26px',
                                lineHeight: '26px',
                                marginRight: (i == buttonFields.length-1)? '0px': '5px',
                                marginTop: '5px',
                                display: 'inline-block'
                            }, styleText),
                            content: titles[i] + ' (' + length + ')',
                            data: { 
                                field: cF,
                                value: this.data[cF],
                                source: f.split('_')[0],
                                length
                            }
                        },
                        events: {
                            click: (event, ctrl) => { 
                                let filter = {};
                                filter[ctrl.data.field] = ctrl.data.value; 
                                state.set('filter', filter);
                                state.set('source', ctrl.data.source);
                            }
                        }
                    }, Link));
                }
            }
        }

        return extend({
            properties: {
                style: {
                    padding: '0% 2% 0% 20%'
                }
            },
            children: result
        }, Group);

    }

    linkClicked(field, value){
        const source = state.get('source');
        let link = this.linkFields.get(field);
        if(link){
            let newFilter = {};
            for(let f of link.f){
                if(f == field){
                    newFilter[f] = value;
                }else if(this.data[f]){
                     let nV = this.data[f];
                     if((nV instanceof Array) && nV.length > 1 && 
                            (this.data[field] instanceof Array) && 
                            this.data[field].length == nV.length){
                         for(let i = 0; i < nV.length; i++){
                             if(this.data[field][i] == value){
                                 nV = nV[i];
                                 break;
                             }
                         }
                     }

                     newFilter[f] = nV;
                }
            }

            if(link.s){
                if(link.s === 'eval' && source === 'planned'){
                    // when screen is set to eval, having planned evaluation is okay too.
                    // appart from setting the eval id as filter, we also need to set the correct year
                    const currentFilter = state.get('filter');
                    newFilter.year = currentFilter.eval_rpt_end_year;
                }else{
                    state.set('source', link.s);
                }
            }
            state.set('filter', newFilter);
            state.set('view', link.v);
            state.set('list', null);
            
        }
    }

    getValueChildren(field, value){
        let result = [];
        if(! (value instanceof Array)){
            value = [value];
        }else if(value.length === 1 && (value[0] instanceof Array) && 
                (field.search('theme_combined') === -1)){
            // for some reason sometimes the array of items is presented inside another array. If this is the
            // case we ignore the outer array. Note that theme_combined is an exception on this rule, because
            // this is an array of [theme_category, theme]
            value = value[0];
        }
        if(field.search('theme_combined') !== -1){
            value = value.sort(function(a,b){
                return a[1].localeCompare(b[1]);
            });
        }else{
            value = value.sort();
        }
        // filter out duplicate values from the list
        value = value.filter((item, i, values) => (values.indexOf(item) >= i));
        for(let val of value){
            let displayVal = val;
            let newField = field;
            if(val == '__EMPTY__'){
                // when we have multiple values and this one is empty, we simply skip it.
                if(value.length > 1){
                    continue;
                }
                displayVal = '-'; 
            }else if(field == 'll_desc' || field == 'gp_desc' || field == 'rec_desc'){
                // continue;
                if(val.length > 200){
                    let part = this.models['details'].getCountField().split('_')[0];
                    if(part != field.substring(0, part.length)){
                        displayVal = val.substring(0,200) + '...';
                    }
                }
                if(value.length > 1){
                    displayVal = '• ' + displayVal;
                } 
            }
            // if(field == 'buttons'){
               
            //     return result;
            // }
            if(field == 'completion_date' || field == 'planned_completion_date' || field == 'rec_date'){
                if(displayVal.length > 10){
                    let date = new Date(displayVal.substring(0,10));
                    let months = ["January", "February", "March", "April", "May", "June", "July", 
                            "August", "September", "October", "November", "December"];
                    displayVal = months[date.getMonth()] + /*' ' + date.getDate() + */ ', ' + date.getFullYear();
                }else{
                    displayVal = 'unknown date';
                }
            }

            if((field == 'management_response' && (! this.data['rec_id'] || this.data['rec_id'] == '__EMPTY__')) || 
                    (field == 'rec_response' && (! val || val == '__EMPTY__'))){
                val = 'Pending';
            }else if(field == 'management_response'){
                continue;
            }

            if(field == 'doc_title'){
                displayVal = '-';
                if(this.data['doc_id'] && this.data['doc_id'] instanceof Array){
                    for(let i = 0; i < this.data['doc_id'].length; i++){
                        if(this.data['doc_title'][i] == val && val !== '__EMPTY__'){
                            displayVal = this.data['doc_title'][i] || '';
                            val = this.data['doc_id'][i];
                            break;
                        }
                    }
                }

            }

            if(field.search('theme_combined') !== -1){
                if(! val || val.length <= 1){
                    continue;
                }
                let color = config.display.themeColors[trimLowerCase(val[0])] ||
                        config.display.themeColors.default; 
                result.push(extend({
                    properties: {
                        style: extend({ 
                            display: 'block',
                            backgroundColor: 'hsl('+color[0]+','+color[1]+'%,'+color[2]+'%)',
                            textIndent: '40px',
                            overflow: 'hidden',
                            cssFloat: 'left',
                            width: '10px',
                            height: '10px',
                            borderRadius: '5px',
                            marginRight: '5px',
                            marginTop: '5px'
                        }, styleText),
                        attributes:{
                            title: 'Theme category: ' + val[0]
                        },
                        content: val[0],
                        data: { 
                            field,
                            value: val[0]
                        }
                    },
                    events: {
                        click: (event, ctrl) => {
                            ctrl.parent.parent.parent.linkClicked(ctrl.data.field, ctrl.data.value);
                        }
                    }
                }, Link));
                // setting the newField as theme, ll_theme, gp_theme, rec_theme for the combined themes.
                newField = field.replace("_combined","");
                val = val[1];
                displayVal = val;

            }

            if(this.linkFields.has(newField) && val != '__EMPTY__'){
                let styleLink = extend({ 
                            display: 'inline',
                            textDecoration: 'underline',
                            color: '#1E2DBE',
                            marginBottom: (ctrl) => (
                                (['ll_desc', 'gp_desc', 'rec_desc'].indexOf(ctrl.data.field) == -1) ?
                                        '0px': '15px'
                            ) 
                        }, styleText);
                // if(newField == 'doc_title'){
                //     let index = 0;
                //     let skip = false;
                //     for(let t of this.data['doc_title']){
                //         if(t == val){
                //             if(this.data['doc_id'][index] && this.data['doc_id'] && 
                //                     this.data['doc_id'][index] == this.data['doc_id']){
                //                 skip = true;
                //             }
                //         }
                //         index++;
                //     }
                //     if(skip){
                //         continue;
                //     }
                //     // styleLink = createObjectFromDefault({
                //     //     background: 'transparent url(\'' + config.imgPath + 'download_small.png\') 5px top no-repeat',
                //     //     padding: '0px 0px 0px 25px',
                //     // }, styleLink); 
                // }

                let linkVal = extend({
                    properties: {
                        style: styleLink,
                        content: displayVal,
                        data: { 
                            field: newField,
                            value: val
                        }
                    }
                }, Link);

               
                if(field === 'doc_title'){
                    linkVal.properties.attributes = {
                        download: 'download',
                        href: config.documentUrl + val
                    }
                }else{
                    linkVal.events = {
                        click: (event, ctrl) => { 
                            if(ctrl.parent.parent.parent.linkClicked){
                                ctrl.parent.parent.parent.linkClicked(ctrl.data.field, ctrl.data.value);
                            }else{
                                ctrl.parent.parent.parent.parent.linkClicked(ctrl.data.field, ctrl.data.value);
                            }
                        }
                    }
                }
                // When we have multiple countries, regions, etc., seperate the links
                const listOfFields = ['country', 'region','doc_title', 'administrative_unit',
                        'funding_source', 'tech_unit', 'eval_manager'];
                if(listOfFields.includes(field) && result.length !== 0){
                    linkVal = extend({
                        properties: {
                            style: {
                                display: 'block',
                            },
                            data: linkVal.properties
                        },
                        children: [
                            cloneObject(linkVal)
                        ]
                    }, Group);
                }

                // Add link element
                result.push(linkVal);

                if(newField == 'theme'){
                    // add a empty group to clear the float
                    result.push(extend({
                        properties: {
                            style: { clear: 'left' }
                        }
                    }, Group));
                }else if(newField == 'doc_title'){
                    // add a parent around the link, with padding and background
                    // this also convienently seperates the different rows
                    let child = result[result.length-1];
                    result[result.length-1] = extend({
                        properties: {
                            style: { 
                                background: 'transparent url(\'' + config.imgPath + 'download_small.png\') 0px top no-repeat',
                                padding: '0px 0px 0px 25px',
                            },
                            data: child.properties
                        },
                        children: [child]
                    }, Group);
                }else if(newField == 'tc_symbol'){
                    let child = result[result.length - 1];
                    const symbol = '' + (val || '');
                    // If the symbol starts with NO_DC_SYMBOL we will not create a link to the dc dashbard,
                    // in all other cases we will
                    if(symbol.search(/NO_DC_SYMBOL/i) == -1 && symbol.search(/not available/gi) == -1){
                        result[result.length - 1] = extend({
                            properties: {
                                attributes: {
                                    href: config.dcDashboardUrl + '#project_symbol=' +
                                            ('' + (val || '')).replace(/\//g, '-'),
                                    target: '_blank'
                                },
                                data: child.properties,
                                style: {display: 'block'}
                            },
                            children: [
                                extend({
                                    properties: {
                                        content: child.properties.content,
                                        style: child.properties.style,
                                    }
                                }, TextBox),
                                extend({
                                    properties: {
                                        style: extend({
                                            background: 'transparent url(\'' + config.imgPath + 'external-link.svg\') center center no-repeat',
                                            backgroundSize: '16px 16px',
                                            height: '16px',
                                            width: '16px',
                                            verticalAlign: 'middle',
                                            display: 'inline-block',
                                            margin: '0px 10px 0px 5px',
                                            textDecoration: 'none'
                                        }, styleLink),
                                        content: ''
                                    }
                                }, TextBox)
                            ]
                        }, Link);
                    }else{
                        // Render project symbol as ordinairy text (also no link to filter)
                        result[result.length - 1] = extend({
                            properties: {
                                content: child.properties.content,
                                style: {},
                            }
                        }, TextBox);
                    }
                }
                
            }else{  // not a link
                result.push(extend({
                    properties: {
                        style: extend({ 
                            display: 'block'
                        }, styleText),
                        content: displayVal
                    }
                }, TextBox));
            }

        }//for

        if(result.length == 0){
            result.push(extend({
                properties: {
                    style: extend({ 
                        display: 'block'
                    }, styleText),
                    content: "-"
                }
            }, TextBox));
        }

        return result;
    }

} 



let Blueprint = extend({
    type: Controller,
    models: {
        'details': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['details'], [ctrl, ctrl.update]) )
    ],
    properties: {
        style: {
            borderTop: '1px solid #f2ece7',
            display: 'block',
            backgroundColor: '#f7f3ef',
            padding: ' 10px 0px' 
        }
    },
    children: [ 
        (ctrl) => (ctrl.getLines() ),
         
     ]
}, Group);


let BlueprintLine = extend({
    properties: {
        style: { padding: '5px 0px'}
    },
    children: [
        extend({
            properties: {
                style: extend({ 
                    display: 'block',
                    cssFloat: (ctrl) => ( (state.get('renderSize') == 'small')? 'none': 'left'),
                    width: (ctrl) => ( (state.get('renderSize') == 'small')? 'auto': '13%'),
                    paddingLeft: '5%',
                    paddingRight: '2%',
                    fontSize: '9pt',
                    fontStyle: (ctrl) => ( (state.get('renderSize') == 'small')? 'italic': 'normal')
                }, styleText),
                content: (ctrl) => ( config.data.dimensionTitles[ctrl.parent.data.label] + ':' )
            }
        }, TextBox),

        extend({
            properties: {
                style: {
                    display: 'block',
                    cssFloat: (ctrl) => ( (state.get('renderSize') == 'small')? 'none': 'left'),
                    width: (ctrl) => ( (state.get('renderSize') == 'small')? 'auto': '75%'),
                    paddingLeft: (ctrl) => ( (state.get('renderSize') == 'small')? '5%': '0px'),
                }
            },
            children: [ 
                (ctrl) => (
                    ctrl.parent.parent.getValueChildren(ctrl.parent.data.label, ctrl.parent.data.value)
                )
            ]
        }, Group),

        extend({
            properties: {
                style: {clear: 'left'}
            }
        }, Group)
    ]
}, Group);



export default Blueprint;
export {Controller, Blueprint};

